import { render, staticRenderFns } from "./SetMeal.vue?vue&type=template&id=67c62c42&scoped=true"
import script from "./SetMeal.vue?vue&type=script&lang=js"
export * from "./SetMeal.vue?vue&type=script&lang=js"
import style0 from "./SetMeal.vue?vue&type=style&index=0&id=67c62c42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c62c42",
  null
  
)

export default component.exports